import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/quickSearch';

export const QUICK_SEARCH_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const QUICK_SEARCH_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const QUICK_SEARCH_GSP_SUGGESTIONS_GET_SUCCESS = `${rootActionPath}/gspSuggestions/GET_${SUCCESS_SUFFIX}`;
export const QUICK_SEARCH_GSP_SUGGESTIONS_GET_FAILURE = `${rootActionPath}/gspSuggestions/GET_${FAILURE_SUFFIX}`;
